import { render, staticRenderFns } from "./ExpandBox.vue?vue&type=template&id=5c3f8afd&scoped=true"
import script from "./ExpandBox.vue?vue&type=script&lang=js"
export * from "./ExpandBox.vue?vue&type=script&lang=js"
import style0 from "./ExpandBox.vue?vue&type=style&index=0&id=5c3f8afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f8afd",
  null
  
)

export default component.exports